import ActionType from '../actions/ActionType'
import { omit } from 'lodash'

export default (state = {}, action) => {
  switch (action.type) {
    case ActionType.Schemas.LOAD_CREATE_SCHEMAS_SUCCESS:
      return action.payload.reduce(
        (schemasByType, schema) => {
          if (schemasByType[schema.type]) {
            schemasByType[schema.type] = { ...state[schema.type], POST: omit(schema, 'type') }
          } else {
            schemasByType[schema.type] = { POST: omit(schema, 'type') }
          }
          return schemasByType
        },
        { ...state },
      )
    case ActionType.Schemas.SUCCESS:
      return {
        ...state,
        [action.payload.schema.type]: {
          [action.payload.requestType]: omit(action.payload.schema, 'type'),
        },
      }
    default:
      return state
  }
}
